/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class referenceidentification extends IceEntity {
  reference_identification_key: string = "";
  reference_identification_qualifier: string = "";
  reference_identification_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "REFERENCE_IDENTIFICATION";
  }
}

